import { Injectable } from '@angular/core';

import { IdInterface, ProductInterface } from '../data';
import { MemoryMapCacheRepository } from './memory-map-cache.repository';

@Injectable()
export class ProductDetailCacheRepository extends MemoryMapCacheRepository<ProductInterface> {
    getKey(id: IdInterface): string {
        return 'ProductDetailCacheRepository' + id.value;
    }
}
